import {twMerge} from '../../../common/twMerge';
import {TalkPosition} from '../../../domain/content/[seriesId]/viewer/[productId]/type/TalkPosition.enum';
import {TalkTailProps} from './TalkTailProps.interface';

export default function BubbleTail({talkPosition, talkColor}: TalkTailProps) {
  if (talkPosition === TalkPosition.Center) {
    return null;
  }
  return (
    <svg
      className={twMerge(
        // z-index -1 을 주게 되면 z-index가 지정되지 않은 auto값 컨텐츠 뒤에 위치하게 된다. (https://stackoverflow.com/a/59785721/11617666)
        'absolute top-0 -z-1 h-25tvs w-30tvs',
        talkPosition === TalkPosition.Left && 'left-6tvs-minus scale-x-[-1]',
        talkPosition === TalkPosition.Right && 'right-6tvs-minus scale-x-[1]'
      )}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 37 30"
    >
      <path
        fill={talkColor}
        fillRule="evenodd"
        d="M30 21a29.77 29.77 0 0 1 5.943-17.88A14.15 14.15 0 0 0 34.098 3 13.975 13.975 0 0 0 23.09 8.35C18.34 3.213 11.546 0 4 0H-9c-14.36 0-26 11.64-26 26v10c0 14.36 11.64 26 26 26H4c14.36 0 26-11.64 26-26V21z"
      />
    </svg>
  );
}
